'use client';

import { getSearchSuggestions } from '../api/getSearchSuggestions';
import {
  storeSearchSuggestion,
  selectQuery,
  selectSuggestionLimit
} from '../lib/store';

import { historyActions } from './history';

const search = async (query: string) => {
  storeSearchSuggestion.send({
    type: 'setQuery',
    query
  });

  storeSearchSuggestion.send({
    type: 'setLoading',
    isLoading: true
  });

  const suggestionLimit = selectSuggestionLimit(
    storeSearchSuggestion.getSnapshot()
  );
  const suggestions = await getSearchSuggestions(query, suggestionLimit);

  // Вместо AbortController
  const currentQuery = selectQuery(storeSearchSuggestion.getSnapshot());
  if (currentQuery !== query) {
    return;
  }

  if (!('error' in suggestions)) {
    storeSearchSuggestion.send({
      type: 'set',
      state: suggestions
    });

    historyActions.addItem(query);
  }

  storeSearchSuggestion.send({
    type: 'setLoading',
    isLoading: false
  });
};

export const searchActions = {
  search
};
